import { NgModule } from '@angular/core';
import { PanelComponent } from './panel.component';
import { PanelHeaderComponent } from './panel-header/panel-header.component';
import { PanelContentComponent } from './panel-content/panel-content.component';

@NgModule({
  imports: [PanelComponent, PanelHeaderComponent, PanelContentComponent],
  exports: [PanelComponent, PanelHeaderComponent, PanelContentComponent],
})
export class AppPanelModule {}
